import React from 'react';
export function Navbar() {
  return <nav className="sticky top-0 z-50 w-full bg-white/90 backdrop-blur-md border-b border-beige-dark ml-[0px] mr-[0px]" data-id="element-225">
      <div className="max-w-container mx-auto px-4 sm:px-6 lg:px-8 h-16 flex pt-[0px] pb-[0px] pl-[0px] pr-[0px] mt-[0px] mb-[0px] ml-[0px] mr-[0px] gap-[35px] flex-row items-center justify-center" data-id="element-226">
        <div className="flex items-center gap-2" data-id="element-227">
          <img src="https://cdn.magicpatterns.com/uploads/nsstjYDUdvYZEG9tfrBSCC/Zentral_Pro_Png.png" alt="Zentral Pro" className="w-8 h-8 object-contain" data-id="element-228" />
          <span className="font-serif font-bold tracking-wide text-charcoal text-[18px]" data-id="element-229">
            ZENTRAL PRO™
          </span>
        </div>
        <div className="hidden md:flex items-center gap-6 text-sm font-medium text-gray-600" data-id="element-230">
          <a href="#sistema" className="hover:text-gold transition-colors" data-id="element-231">
            El Sistema
          </a>
          <a href="#bonos" className="hover:text-gold transition-colors" data-id="element-232">
            Bonos
          </a>
          <a href="#precios" className="hover:text-gold transition-colors" data-id="element-233">
            Precios
          </a>
        </div>
        <a href="#precios" className="bg-terracotta hover:bg-terracotta-light text-white px-6 py-2.5 rounded font-bold text-sm transition-colors shadow-sm" data-id="element-234">
          Acceder Ahora
        </a>
      </div>
    </nav>;
}